module.exports = __webpack_public_path__ + "img/ceratostigma-plumbaginoides.8b4c9a1e.webp";